export const SimulasiHeader = {
    headline: 'Simulasi Investasi',
};

export const ProfilRisikoHeader = {
    headline: 'Profil Risiko',
};